import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=b0da9b7a"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=b0da9b7a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0da9b7a')) {
      api.createRecord('b0da9b7a', component.options)
    } else {
      api.reload('b0da9b7a', component.options)
    }
    module.hot.accept("./dataTable.vue?vue&type=template&id=b0da9b7a", function () {
      api.rerender('b0da9b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/vueComponents/dataTable/src/dataTable.vue"
export default component.exports